import { defineStore } from 'pinia'
import { store } from '../index'
import { GetWorkShift } from '@/api/oee'
import { GetNodesByGroup, GetGroupByProject, GetAllTemplates } from '@/api/apm'
import { GetSystemSetting } from '@/api/mu'
import { Utc2Localtime, ConvertShiftTime } from '@/utils'
import { InitTreeNodeList } from '@/utils/tree'
import { SYSTEM_SETTING_TYPE } from '@/config/global'

export const useAreaStore = defineStore({
  id: 'Area',
  state: () => ({
    service:'',
    assetId:null as any,
    assetName:'',
    assetList: [] as any,
    assetLevel: 0,
    allNodeList: null as any,
    treeData: null as any,
    devList: null as any,
    assetTypeMapping: null as any,
    templates: null as any,
  }),
  getters: {
    getService(): any {
      return this.service
    },    
    getAssetId(): any {
      return this.assetId
    },    
    getAssetName(): any {
      return this.assetName
    },
    getAssetList(): any {
      return this.assetList
    },
    getAssetLevel(): any {
      return this.assetLevel
    },       
    getTreeData(): any {
      return this.treeData
    },        
    getAllNodeList(): any {
      return this.allNodeList
    },
    getAssetTypeMapping(): any {
      return this.assetTypeMapping
    },
    getTemplates(): any {
      return this.templates
    },    
  },
  actions: {
    setService(){
      const service = window.$wujie?.props?.service
      if(service){
        this.service = service
      }      
    },
    async InitAssetList() {
      if(window.$wujie){
        try{
          const wujieConfig = window.$wujie?.props?.dataSourceInfo
          if(wujieConfig){
            const type = wujieConfig.type  //"group" {name: '水冷能源站', id: 56} "project" {name: 'MU', id: 2}
            const value = wujieConfig.value
            let isGroup = false
            let isProject = false
            if(Array.isArray(type)){
              isGroup = type.includes("group")
              isProject = type.includes("project")
            }else{
              isGroup = (type=="group")
              isProject = (type=="project")
            }
            if(!isGroup && !isProject){
              return
            }            
            if(!value || value.length==0){
              return
            }
            // if(isGroup){
            //   this.assetList = [...value]
            // }else if(isProject){
              const params:any = {
                // projectName:value.map(item=>item.name),
                gteGrade:2,
                count:1000
              }
              if(!isGroup){
                params.projectName = value.map(item=>item.name)
              }
              const res = await GetGroupByProject(params)
              if(!res || !res.e || res.e.length==0){
                return
              }
              this.assetList = res.e.map(item=>{
                return {
                  id:item.id,
                  name:item.name
                }
              })
            // }
          } 
        }catch(error){
          console.log(error)
          return
        }       
      }else{
        const params = {
          gteGrade:2,
          count:1000
        }        
        const res = await GetGroupByProject(params)
        if(!res || !res.e || res.e.length==0){
          return
        }
        this.assetList = res.e.map(item=>{
          return {
            id:item.id,
            name:item.name
          }
        })
      }
    },    
    async getAreaTreeData(resetFlag:any=false) {
      if(!resetFlag && this.allNodeList){
        return this.treeData
      }
      if(!this.assetId) return
      const assetObj = this.assetList.find(item=>item.id==this.assetId)
      if(assetObj){
        const {tree,allNodeList,devList,level} = await InitTreeNodeList(assetObj.id)
        this.allNodeList = allNodeList
        this.treeData = tree
        this.assetLevel = level
        return tree        
      }
    },
    clearTreeData(){
      this.allNodeList = null
      this.treeData = null
      this.devList = null
      this.assetLevel = 0
    },
    async InitAssetTypeMapping(){
      const params = {
        type: 'asset-type-mapping'
      }
      const res = await GetSystemSetting(params)
      if(res && !res.errorCode && res.setting){
        const list = JSON.parse(res.setting)
        if(list){
          this.assetTypeMapping =  list
        }
      }
    },
    async InitTemplates(){
      if(this.templates) return this.templates
      const res = await GetAllTemplates()
      if(res?.template){
        this.templates = res.template
      }
      return this.templates
    }
  }
})

export const useAreaStoreWithOut = () => {
  return useAreaStore(store)
}
